const MamuriatSazmani = () => {
  return (
    <>
      <ul>
        <li>
          تولید محصولات با کیفیت منطبق بر استانداردهای جهانی و با قیمت رقابتی
          برای تولید کنندگان محصولات نهایی
        </li>
        <li>
          ما بر این باوریم که بیش از هر چیز در برابر مشتریان و تمام کسانی که از
          محصولات ما استفاده می کنند مسئول هستیم.
        </li>
        <li>
          محصولات اصلی شرکت ما از این قرار است:شمش آلیاژی آلومینیوم، بیلت،گرانول
          و... است.
        </li>
        <li>
          ما بیشتر توجه خود را به بازارهای داخلی معطوف می کنیم، اگرچه می کوشیم
          هیچگاه فرصتهای جهانی را هم از دست ندهیم.
        </li>
        <li>
          شرکت از بروزترین فناوری برای بالابردن کیفیت محصول استفاده می کند.
        </li>
        <li>
          شرکت با چشمداشتی به سودی منصصفانه می کوشداطلاعاتی ارزشمند را
          گردآوری،ارزیابی، پردازش و توزیع نماید به گونه ای که منافع مشتریان،
          کارکنان، سرمایه گذاران و جامعه تامین گردد.
        </li>
        <li>
          ما براین باوریم توسعه انسان از ارزشمندترین هدفهای تمدن است و تلاش ما
          در این جهت است که بهترین شرایط برای رشد و تقویت توانایی انسان فراهم
          آورد.
        </li>
        <li>
          ما متعهد هستیم که هر روز به اتکای انرژی فزاینده و توانایی های خلاق و
          سازنده کارکنان خود، جهش های بلندپروازانه ای در بازار رقابت بنماییم.
        </li>
        <li>حفظ مصالح اجتماعی( به ویژه زیست محیطی)</li>
        <li>
          رشد و ارتقا تخصصی و نگرشی همکاران و تقدیر ازعملکردهای متمایز ایشان
        </li>
      </ul>
    </>
  );
};

export default MamuriatSazmani;
